<template>
    <pdf-layouts 
    :detailInfo="GETTERS_INPUT_ALL">
        <template v-slot:method>
            {{method}}
        </template>
        <template v-slot:additional_equipment>
            {{additional_equipment}}
        </template>
        <template v-slot:expert>
            <span v-if="expert.status">
                {{expert.individual.last_name}}
                {{expert.individual.first_name}}
                {{expert.individual.middle_name}}
                
            </span>
            <span v-else>{{expert.text}}</span>
        </template>
        <template v-slot:team>
            <span v-if="!team.hasOwnProperty('error')">
                <span v-for="(item, i) in team" :key="i">
                    ID: {{item.id}}
                    <v-spacer></v-spacer>
                    {{item.individual.last_name}}
                    {{item.individual.first_name}}
                    {{item.individual.middle_name}}
                    
                    <v-spacer></v-spacer>
                </span>
            </span>
            <span v-else>
                Нет данных
            </span>
        </template>
        <template v-slot:scientific_subjects>
           <span v-if="!scientific_subjects.hasOwnProperty('error')">
                ID: {{scientific_subjects.id}}
                <v-spacer></v-spacer>
                {{scientific_subjects.name}}
           </span>
           <span v-else>Нет данных</span>
        </template>
        <template v-slot:stations>
           <span v-if="!stations.hasOwnProperty('error')">
                <span v-for="(item, i) in stations" :key="i">
                    ID: {{item.id}}
                    <v-spacer></v-spacer>
                    {{item.name}}
                    <v-spacer></v-spacer>
                </span>
           </span>
           <span v-else>
               Нет данных
           </span>
        </template>
        <template v-slot:previous_proposals>
            <span v-if="!previous_proposals.hasOwnProperty('error')">
                <span v-for="(item, i) in previous_proposals" :key="i">
                    ID: {{item.id}}
                    <v-spacer></v-spacer>
                    {{item.name}}
                    <v-spacer></v-spacer>
                </span>
            </span>
            <span v-else>Нет данных</span>
        </template>
        <template v-slot:applicant>
           
            <span v-if="!applicant.hasOwnProperty('error')">
                ID: {{applicant.id}}
                <v-spacer></v-spacer>
                {{applicant.individual.last_name}}
                {{applicant.individual.first_name}}
                {{applicant.individual.middle_name}}
                
                <v-spacer></v-spacer>
            </span>
            <span v-else>Нет данных</span>
        </template>
        <template v-slot:status>
            <span v-if="!status.hasOwnProperty('error')">
                <span v-for="(item, i) in status" :key="i">
                    ID: {{item.id}}
                    <v-spacer></v-spacer>
                    {{item.individual.last_name}}
                    {{item.individual.first_name}}
                    {{item.individual.middle_name}}
                    
                    <v-spacer></v-spacer>
                    {{$t('comments')}}: {{item.comments || 'Нет комментария'}}
                    <v-spacer></v-spacer>
                </span>
            </span>
            <span v-else>Нет данных</span>
        </template>
        <template v-slot:current_status>
            ID: {{current_status.id}}
            <v-spacer></v-spacer>
            {{current_status.individual.last_name}}
            {{current_status.individual.first_name}}
            {{current_status.individual.middle_name}}
            
            <v-spacer></v-spacer>
        </template>
        <template v-slot:comments>
            <span v-if="!comments.hasOwnProperty('error')">
                <span v-for="(item, i) in comments" :key="i">
                    ID: {{item.id}}
                    <v-spacer></v-spacer>
                    {{item.text}}
                    <v-spacer></v-spacer>
                </span>
            </span>
            <span v-else>Нет данных</span>
        </template>
        <template v-slot:files>
            <span v-if="!files.hasOwnProperty('error')">
                <span v-for="(item, i) in files" :key="i">
                    ID: {{item.id}}
                    <v-spacer></v-spacer>
                    {{item.name}}
                    <v-spacer></v-spacer>
                </span>
            </span>
            <span v-else>
                Нет файлов
            </span>
        </template>
    </pdf-layouts>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PdfLayouts from '../layouts/PdfLayouts'

export default {
    name: 'PdfComponents',
    components: {
        PdfLayouts
    },
    computed: {
        ...mapGetters(['GETTERS_INPUT_ALL']),
        method() {
            if (this.GETTERS_INPUT_ALL.method !== null)
                return this.GETTERS_INPUT_ALL.method.name
            else 'Нет данных'
        },
        additional_equipment() {
            if (this.GETTERS_INPUT_ALL.additional_equipment !== null)
                return this.GETTERS_INPUT_ALL.additional_equipment
            else 'Нет данных'
            
        },
        expert() {

            if (this.GETTERS_INPUT_ALL.expert !== null) {
                let expert = {};
                expert.individual = this.GETTERS_INPUT_ALL.expert.individual;
                return {...expert, status: true}
            } else {
                return {text: 'Эксперт не назначен', status: false}
            }
            
        },
        team() {

            if (this.GETTERS_INPUT_ALL.team !== null) {
                const team = [];
                this.GETTERS_INPUT_ALL.team.forEach(item => {
                    team.push({
                        id: item.id,
                        individual: {...item.individual}  
                    })  
                })
                return team
            } else return {error: 'error'}
            
        },
        scientific_subjects() {
            if ((this.GETTERS_INPUT_ALL.scientific_subjects !== undefined) && (this.GETTERS_INPUT_ALL.scientific_subjects !== null))
                return {
                    id: this.GETTERS_INPUT_ALL.scientific_subjects.id,
                    name: this.GETTERS_INPUT_ALL.scientific_subjects.name
                }
            else return {error: 'error'}
            
        },
        stations() {
            
            if ((this.GETTERS_INPUT_ALL.stations.length !== 0) && (this.GETTERS_INPUT_ALL.stations !== null)) {
                const stations = [];
                this.GETTERS_INPUT_ALL.stations.forEach(item => {
                    stations.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return stations
            } else return {error: 'error'}
            
        },
        previous_proposals() {

            if ((this.GETTERS_INPUT_ALL.previous_proposals.length !== 0) && (this.GETTERS_INPUT_ALL.previous_proposals !== null)) {
                const previous_proposals = [];
                this.GETTERS_INPUT_ALL.previous_proposals.forEach(item => {
                    previous_proposals.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return previous_proposals
            } else return {error: 'error'}
            
        },
        applicant() {

            if (this.GETTERS_INPUT_ALL.applicant !== null) {
                return {
                    id: this.GETTERS_INPUT_ALL.applicant.id,
                    individual: {...this.GETTERS_INPUT_ALL.applicant.individual}   
                }
            } else return {error: 'error'}
        },
        status() {

            if ((this.GETTERS_INPUT_ALL.status.length !== 0) && (this.GETTERS_INPUT_ALL.status !== null)) {
                const status = [];
                this.GETTERS_INPUT_ALL.status.forEach(item => {
                    status.push({
                        id: item.id,
                        individual: {...item.init_by},
                        comments: item.comments
                    })
                })
                return status
            } else return {error: 'error'}
            
        },
        current_status() {

            return {
                id: this.GETTERS_INPUT_ALL.current_status.id,
                individual: {...this.GETTERS_INPUT_ALL.current_status.init_by}   
            }
        },
        comments() {
            
            if (this.GETTERS_INPUT_ALL.comments.length !== 0 && this.GETTERS_INPUT_ALL.comments !== null) {
                const comments = [];
                this.GETTERS_INPUT_ALL.comments.forEach(item => {
                    comments.push({
                        id: item.id,
                        text: item.text
                    })
                })
                return comments
            } else return {error: 'error'}
            
           
        },
        files() {
            
            if ((this.GETTERS_INPUT_ALL.files.length !== 0) && (this.GETTERS_INPUT_ALL.files !== null)) {
                const files = [];
                this.GETTERS_INPUT_ALL.files.forEach(item => {
                    files.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return files
            } else return {error: 'error'}
            
            
           
        }
    },
    methods: {
        ...mapActions(['GET_INPUT_ALL'])
    },
    async mounted() {
        // console.log(this.$route)
        await this.GET_INPUT_ALL(this.$route.params.id)
    },
}
</script>